// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_gM","advertCardPhoto__image":"c-a_gN"};